import type { ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'
import { UnleashFlags } from '../models/feature-flag.models'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { createMsTeamsIntegrationConfigIfFlagEnabled } from '../helpers/ms-teams-integration-helpers'

const integrationFlagSuffix = 'oos-meeting-meet-now'
const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-meeting-meet-now',
  get url() {
    const version = getFeatureFlag(UnleashFlags.OOS_MEET_NOW_VERSION, 'release')
    return new URL(getOOSArtifactUrl('meeting-meet-now-extension', version))
  },
  integrations: {
    get msTeams() {
      return createMsTeamsIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
    },
  }
}

export default extensionConfig
